<template>
  <Banner text="Challenge en cours" :route="challengeRoute" :icons="['🏆']" />
</template>

<script>
import { Banner } from "@estaly/ui";

export default {
  components: {
    Banner,
  },
  computed: {
    challengeRoute() {
      return "/pos/challenge/current";
    },
  },
};
</script>
